var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftsidecallicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-113 -719)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 20,
    height: 20,
    transform: "translate(113 719)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftsidecallicon",
    d: "M10.856,13.144A12.634,12.634,0,0,1,8.218,9.335a.749.749,0,0,1,.166-.827L9.2,7.69a1.53,1.53,0,0,0,.085-2.206L8.114,4.31a2,2,0,0,0-2.828,0l-.652.652a3.194,3.194,0,0,0-.85,2.87,15.715,15.715,0,0,0,4.461,7.923,15.715,15.715,0,0,0,7.923,4.461,3.194,3.194,0,0,0,2.87-.85l.651-.651a2,2,0,0,0,0-2.828l-1.173-1.173a1.5,1.5,0,0,0-2.121,0l-.9.9a.749.749,0,0,1-.827.166,12.66,12.66,0,0,1-3.809-2.64Z",
    transform: "translate(110.776 716.776)",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftsidecallicon);
export default __webpack_public_path__ + "static/media/leftsidecallicon.888082f0c68311e592e5fddb76e42338.svg";
export { ForwardRef as ReactComponent };